import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import "./GettingStarted/gettingStarted.css";
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import {doubleToStringMonthly, standardNumberFormat} from '../../objects/CommonUse/double_functions';
import { determineCollegeLoanObj } from '../../objects/AssetsExpenses/determine_college_loan_obj';
import {monthlyLoanAmt} from '../../objects/AssetsExpenses/loanAmtCalc_function';
import { monthlyExpenseAmt } from '../../objects/monthlyCalc/monthlyAmt_function';
import {calcTaxAmt} from '../../objects/AssetsExpenses/taxAmtCalc_function';
import ConfigFile from '../../datasets/config_file';
import FinalModalCard from './final_modal_card';
import {findDataObject} from '../../objects/CommonUse/find_data_object';
import determineMoodPoints from '../../objects/CommonUse/determine_mood_points';
import { createMoodPointArr } from '../shared-components/objects/create_mood_point_arr';
import { getExtraCreditForNewGame } from '../../objects/AssetsExpenses/get_extra_credit_for_new_game';
import { getBadgesEarnedForNewGame } from '../../objects/AssetsExpenses/get_badges_earned_for_new_game';
import buildMonthlyAmtArr from './objects/build_monthly_amt_arr';
import buildOneTimeCostArr from './objects/build_one_time_cost_arr';


class FinalConfirmModal extends Component {
  carInterest=ConfigFile.carItems.carInterest;
  carLoanTerm=ConfigFile.carItems.carLoanTerm;
  kitchenCost = ConfigFile.homeItems.kitchenCost;
  miscSupplies = ConfigFile.homeItems.miscSupplies;

  constructor(props) {
    super(props);
    this.state={
      buttonDisabled: false,
      expandMonthlyAmts: false,
      expandOneTimeAmts: false,
      expandMoodPoints: false,
    };   
    this.prepareFinalModal(); 
  }
  
  prepareFinalModal() {
    this.retrieveUserInputs();
   
    // Need to review from below on
    this.buildLoanObject();
    this.buildExpenseObject();
    this.monthlyAmtArr = buildMonthlyAmtArr(this.assetArr, this.expenseArr, this.loanData, this.jobName);
    this.buildOneTimeCostArr();
    this.determineStartingMoodPoints();
  }
  
  retrieveUserInputs()
  {
      this.jobName = sessionStorage.getItem("careerName");
      this.previousJobName = sessionStorage.getItem("previousJobName");
      if (!this.jobName || this.jobName !== this.previousJobName)
      {  
          this.jobChanged = true;
      } else {
          this.jobChanged = false;
          this.totalTaxAmt = parseFloat(sessionStorage.getItem("jobTaxAmt"));
      };
      this.salary = (+sessionStorage.getItem("salary") * 1).toFixed(2);
       // Set current Year and Month (will serve as game start date)
      this.setCurrentYYYYMM();
      this.updateJobData();
      if (this.props.extraCreditData.user){
          let extraCreditArr = this.props.extraCreditData.extraCreditTable;
          let extraCreditObj = getExtraCreditForNewGame(extraCreditArr, this.assetArr, this.currentYYYYMM);
          this.totalSalaryIncrease = this.totalSalaryIncrease + extraCreditObj.totalSalaryIncrease;
          this.assetArr = extraCreditObj.assetArr;
          this.extraCreditCashAmt = extraCreditObj.totalCashIncrease;
          this.extraCreditDesc = extraCreditObj.oneTimeDesc;
          if (extraCreditObj.allExercisesComplete === true){
              this.props.setExtraCredit();
          }
      }
      if (this.props.badgesEarned &&
          this.props.badgesEarned.length !== 0){
          let badgesEarnedArr = this.props.badgesEarned;
          let badgesEarnedObj = getBadgesEarnedForNewGame(badgesEarnedArr, this.assetArr, this.currentYYYYMM);
          this.totalSalaryIncrease = this.totalSalaryIncrease + badgesEarnedObj.totalSalaryIncrease;
          this.assetArr = badgesEarnedObj.assetArr;
          this.badgesEarnedArr = badgesEarnedArr;
          this.badgesEarnedCashAmt = badgesEarnedObj.totalCashIncrease;
          this.badgesEarnedDesc = badgesEarnedObj.oneTimeDesc;
      }
      sessionStorage.setItem("assetObjects", JSON.stringify(this.assetArr));
      this.totalAnnualSalary = ((+this.salary + +this.totalSalaryIncrease) * 12).toFixed(0);
      this.getTaxAmount();
      this.homeName = sessionStorage.getItem("homeName");
      this.homeCost = sessionStorage.getItem("homeCost");
      this.roommates = sessionStorage.getItem("homeRoommates");
      this.bedrooms = sessionStorage.getItem("homeBedrooms");
      
      this.furnitureName = sessionStorage.getItem("furnitureName");
      this.furnitureCost = sessionStorage.getItem("furnitureCost");
      this.carName = sessionStorage.getItem("carName");
      this.carCost=Number.parseFloat(sessionStorage.getItem("carCost"));
      this.carMPG=Number.parseFloat(sessionStorage.getItem("carMPG"));
      this.carAgeNbr=sessionStorage.getItem("carAgeNbr");
      this.carName=sessionStorage.getItem("carName");
      this.carSize = +sessionStorage.getItem("carSize");
      this.jobHealthInsInd = sessionStorage.getItem("jobHealthInsInd");
   }

  
  setCurrentYYYYMM()
  {
    var today = new Date();
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    this.currentYYYYMM = `${yyyy}-${mm}`;
      sessionStorage.setItem("currentYYYYMM", this.currentYYYYMM);
  }

  async updateJobData()
  {
    this.assetArr = [];
    this.annualSalary = (+this.salary * 12).toFixed(2);
    this.jobDescription = this.jobName + " --> Annual Salary: " +
      doubleToStringMonthly(this.annualSalary);
      
    let assetObj = {assetItem: "Job Salary", assetDesc: this.jobDescription,
      assetAmt: this.salary, assetStartDate: this.currentYYYYMM, assetNbrMonths: "-1"};
    this.assetArr.push(assetObj);
  }

  getTaxAmount() {
      this.totalTaxAmt = calcTaxAmt(this.assetArr);
      sessionStorage.setItem("previousJobName", this.jobName);
      this.taxObj = {expItem: "Payroll taxes", expDesc: "Federal, FICA (Social Security)", 
            expAmount: this.totalTaxAmt, expStartDate: this.currentYYYYMM, expNbrMonths: "-1",
            chargeCreditCard: false};
  }
 
  buildLoanObject() {
      this.loanData = [];
      if (this.carSize !== 50){
           this.setCarLoanAmt();
      }
      this.calculateCollegeCostAmt();
      sessionStorage.setItem("loanDataObjects", JSON.stringify(this.loanData));
  }
 
  setCarLoanAmt() {
        this.carLoanAmt = monthlyLoanAmt(this.carCost, this.carInterest, this.carLoanTerm, "car");
        let nbrMonths = this.carLoanTerm * 12;
        let loanObj = {loanType: "Car Loan", loanDesc: this.carName,
          loanAmt: this.carLoanAmt, loanStartDate: this.currentYYYYMM,
          loanNbrMonths: nbrMonths, loanTotAmt: this.carCost, loanIntRate: this.carInterest,
          loanTerm: this.carLoanTerm};
      this.loanData.push(loanObj);  
  }
   
  calculateCollegeCostAmt(){
        this.nbrYearsCollege = sessionStorage.getItem("jobNbrYearsCollege");
        this.degreeType = sessionStorage.getItem("jobDegreeType");
        this.degreeSpecialty = sessionStorage.getItem("jobDegreeSpecialty")
        let loanDesc = this.degreeType + "-" + this.degreeSpecialty + "(" + this.nbrYearsCollege + " years)";
        let collegeLoanObj = determineCollegeLoanObj(this.nbrYearsCollege, loanDesc, this.currentYYYYMM)
        this.loanData.push(collegeLoanObj);   
  }

  buildExpenseObject(){
        this.expenseArr = [];
        this.expenseArr = monthlyExpenseAmt(this.homeCost, this.roommates, this.bedrooms, this.homeName, 
          this.jobHealthInsInd, this.carMPG, this.currentYYYYMM, this.currentYYYYMM, this.carCost,
          this.carSize);
        this.expenseArr.splice(0, 0, this.taxObj);
        sessionStorage.setItem("expenseObjects", JSON.stringify(this.expenseArr));
   }
 

  buildOneTimeCostArr(){
      let extraCreditInfo = {};
      this.nbrYearsWithParents = 4 - this.nbrYearsCollege;
      this.startingCash = (this.nbrYearsWithParents * 5000) + 3000;
      if (this.props.extraCreditData){
        extraCreditInfo = {
            cashAmt: this.extraCreditCashAmt,
            extraCreditDesc: this.extraCreditDesc }
      }
      let badgesInfo = {};
      if (this.props.badgesEarned &&
          this.props.badgesEarned.length !== 0){
         badgesInfo = {
            cashAmt: this.badgesEarnedCashAmt,
            badgesDesc: this.badgesEarnedDesc }
      }
      this.oneTimeCostArr = buildOneTimeCostArr(
          this.startingCash,
          extraCreditInfo, badgesInfo, 
          this.homeCost, this.roommates,
          this.furnitureName, this.furnitureCost,
          this.kitchenCost,
          this.miscSupplies,
          this.carSize
        )
        this.calculateStartingTotal();
  } 
  
  calculateStartingTotal() {
    this.totalOneTimeAmt = 0;
    let liabilities = 0;
    for (let i=0; i<this.oneTimeCostArr.length; i++){
        this.totalOneTimeAmt += +this.oneTimeCostArr[i].itemAmt;
        if (this.oneTimeCostArr[i].itemAmt < 0){
            liabilities -= this.oneTimeCostArr[i].itemAmt;
        }
    }
    const oneTimeExpObj = {itemName: "Total One Time Amounts", itemDesc: "", 
      itemAmt: this.totalOneTimeAmt, total: true};
    this.oneTimeCostArr.push(oneTimeExpObj);
    sessionStorage.setItem('startingCash', (this.totalOneTimeAmt).toFixed(2));
    let spendingHistory = findDataObject("spendingHistory").spendingHistoryInfo;
    spendingHistory.current10YearSpendAmt = (liabilities * -1).toFixed(2);
    spendingHistory.current10YearMonths = 1;
    sessionStorage.setItem("spendingHistory", JSON.stringify(spendingHistory));
  }

  determineStartingMoodPoints(){
      this.moodPointStartArr = [];
      this.startingMoodPoints = ConfigFile.gameStartItems.startingMoodPoints;
      let gameChoiceArr = createMoodPointArr("all");
      const moodPointStartArr = determineMoodPoints(gameChoiceArr, this.startingMoodPoints);
      let moodPointObj = {itemName: "starting Mood Points", 
        itemDesc: "Mood Points that are Asssigned as a starting point",
        itemAmt: this.startingMoodPoints}
      this.moodPointStartArr.push(moodPointObj);
      this.totalMoodPoints = +this.startingMoodPoints;
      for (let i=0; i<moodPointStartArr.length; i++){
           const moodObj = moodPointStartArr[i];
           moodPointObj = {itemName:  moodObj.item, itemDesc: moodObj.label,  
              itemAmt: moodObj.number, total: false};
           this.moodPointStartArr.push(moodPointObj);
           this.totalMoodPoints += +moodObj.number;
      }
      moodPointObj = {itemName: "Total Starting Mood Points", itemDesc: "", itemAmt: this.totalMoodPoints,
        total: true};
      this.moodPointStartArr.push(moodPointObj);
      let moodPointHistory = findDataObject("moodPointHistory").moodPointHistoryInfo;
      moodPointHistory.moodPointMonths = 1;
      sessionStorage.setItem("startingMoodPoints", this.totalMoodPoints);
      sessionStorage.setItem("moodPointHistory", JSON.stringify(moodPointHistory));
  }

  checkForExtraCreditCashAmts(){
    let extraCreditArr = this.props.extraCreditData.extraCreditTable;
    let extraCreditAmt = 0;
    if (extraCreditArr){
      for (let i=0; i<extraCreditArr.length; i++){
        if (extraCreditArr[i].assetType === "cash"){
            extraCreditAmt = +extraCreditAmt + +extraCreditArr[i].amount;
        }
      }
     
    }
  }

  toggleDetailAmts(amtType){
      switch (amtType){
          case "monthlyAmts":
            this.setState({expandMonthlyAmts: !this.state.expandMonthlyAmts});
            break;
          case "oneTimeAmts":
            this.setState({expandOneTimeAmts: !this.state.expandOneTimeAmts});
            break;
          case "moodPoints":
            this.setState({expandMoodPoints: !this.state.expandMoodPoints});
            break;
          default:
            break;
      }
  }

  render() {
                
            this.monthlySummaryAmts = this.monthlyAmtArr.map((monthlyAmts,key) =>
              <FinalModalCard  key={key}  amtType="amount" amountInfo={monthlyAmts} 
              />
            );
                    
            this.oneTimeCostList = this.oneTimeCostArr.map((oneTimeAmt,key) =>
                <FinalModalCard  key={key}  amountInfo={oneTimeAmt} 
                    amtType="amount"
                />
            );

            this.moodPointList = this.moodPointStartArr.map((moodPoints,key) =>
              <FinalModalCard  key={key}  amountInfo={moodPoints} 
                amtType="number"
            />
        );
        let lastIndx = this.monthlyAmtArr.length - 1;
        const monthlyTotalAmt = this.monthlyAmtArr[lastIndx].itemAmt;
        let monthlyAmtClass = "";
        let monthlyDesc = "Amount Added to Your Cash Each Month";
        if (monthlyTotalAmt < 0){
            monthlyAmtClass = "text-danger";
            monthlyDesc = "Amount Subtracted from Your Cash Each Month";
        }
        let startingAmtClass = "";
        if (this.totalOneTimeAmt < 0){
            startingAmtClass = "text-danger";
        }
        const modalClass = "gettingStarted-modal-size modal-with-rounded-corners"
     
    return <>
      <Modal show={this.props.modalOpen}  onHide={() => this.props.onClose()} size="xl" scrollable="true"
          dialogClassName={modalClass} animation={false}>
        <Modal.Header closeButton>
            <Modal.Title className="mx-5">
              Review Selections - Monthly Budget and Starting Cash 
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="gettingStarted-no-scrollbar">
        <div className="mx-5">
            Review your choices below. If you wish to make changes to the choices you've made, click 'Close' 
            and use the buttons on the right.
        </div>
        <div className="mx-5">
             When everything looks good, click 'Start. 
        </div>
        <h5 className="text-center">Monthly Budget Amounts</h5>
        <table className="table table-hover aligned-table mx-5">
          <colgroup>
            <col className="col-item" />
            <col className="col-desc" />
            <col className="col-amount" />
            <col className="col-caret" />
          </colgroup>
          <thead>
              <tr className="table-background">
                <th className="p-0">Item</th>
                <th className="p-0">Description</th>
                <th className="p-0 text-right" scope="col">Amount</th>
                {this.state.expandMonthlyAmts  ? 
                    <th className="py-0 px-4 career_card_caret col-caret"
                        onClick={() => this.toggleDetailAmts("monthlyAmts")}>
                        <FontAwesomeIcon icon={faCaretDown} />
                    </th>
                :
                    <th className="py-0 px-4 career_card_caret col-caret"
                        onClick={() => this.toggleDetailAmts("monthlyAmts")}>
                        <FontAwesomeIcon icon={faCaretRight} />
                    </th>
                }
              </tr>
          </thead>
          <tbody>
            {this.state.expandMonthlyAmts   ? 
              <>
                {this.monthlySummaryAmts}
              </>
            :
              <>
                 <tr className={monthlyAmtClass}>
                      <th className="p-0">Monthly Cash Flow</th>
                      <th className="p-0">{monthlyDesc}</th>
                      <th className="p-0 text-right">{doubleToStringMonthly(monthlyTotalAmt)}</th>
                  </tr>
              </>
            }
          </tbody>
    </table>

    <h5 className="text-center">Starting Cash</h5>   
    {this.nbrYearsCollege < 4 ?
        <div className="table-background mx-5">
          After starting your first job, you lived with your parents for {this.nbrYearsWithParents} years 
          to save money. You paid a small amount for rent and saved a lot. Now it's time to move out on your own.
        </div>
    :
        <div className="table-background mx-5">
           Since you chose college, you didn't save much over the past 4 years. 
           But your summer jobs helped you put some money aside before moving out on your own. 
        </div>
    }     
    <table className="table table-hover aligned-table mx-5">
        <colgroup>
            <col className="col-item" />
            <col className="col-desc" />
            <col className="col-amount" />
            <col className="col-caret" />
          </colgroup>
        <thead>
            <tr className="table-background">
              <th className="p-0 col-item" >Item</th>
              <th className="p-0 col-desc"  style={{ width: '463px' }}>Description</th>
              <th className="p-0 text-right col-amount" >Amount</th>
              {this.state.expandOneTimeAmts  ? 
                  <th className="py-0 px-4 career_card_caret col-caret"
                      onClick={() => this.toggleDetailAmts("oneTimeAmts")}>
                      <FontAwesomeIcon icon={faCaretDown} />
                  </th>
              :
                   <th className="py-0 px-4 career_card_caret col-caret"
                      onClick={() => this.toggleDetailAmts("oneTimeAmts")}>
                      <FontAwesomeIcon icon={faCaretRight} />
                  </th>
              }
            </tr>
          </thead>
          <tbody>
            {this.state.expandOneTimeAmts  ? 
                <>
                  {this.oneTimeCostList}
                </>
            :
                 <tr className={startingAmtClass}>
                      <th className="p-0">Starting Cash Total</th>
                      <th className="p-0" >Starting Cash Minus One-Time Costs</th>
                      <th className="p-0 text-right">{doubleToStringMonthly(this.totalOneTimeAmt)}</th>
                  </tr>
             }
                 
             </tbody>
    </table>
    <h5 className="text-center">Starting Mood Points</h5>   
      <div className="table-background mx-5">
        Your choices affect not just your cash, but also your mood points 
        as you start the next part of the game.
      </div>
      
    <table className="table table-hover aligned-table mx-5">
        <colgroup>
            <col className="col-item" />
            <col className="col-desc" />
            <col className="col-amount" />
            <col className="col-caret" />
          </colgroup>
        <thead>
            <tr className="table-background">
              <th className="p-0" scope="col">Item</th>
              <th className="p-0" scope="col">Description</th>
              <th className="p-0 text-right" scope="col">Amount</th>
              {this.state.expandMoodPoints  ? 
                  <th className="py-0 px-4 career_card_caret col-caret"
                      onClick={() => this.toggleDetailAmts("moodPoints")}>
                      <FontAwesomeIcon icon={faCaretDown} />
                  </th>
              :
                   <th className="py-0 px-4 career_card_caret col-caret"
                      onClick={() => this.toggleDetailAmts("moodPoints")}>
                      <FontAwesomeIcon icon={faCaretRight} />
                  </th>
              }
            </tr>
          </thead>
          <tbody>
            { this.state.expandMoodPoints  ?
              <>
                {this.moodPointList}
              </>
            :
              <tr className="">
                <th className="p-0" scope="row">Total Starting Mood Points</th>
                <th></th>
                <th className="p-0 text-right">{standardNumberFormat(this.totalMoodPoints)}</th>
              </tr>
            }
          
          </tbody>
    </table>
            <div className="text-right">
                <Button className="mr-2" variant="secondary"  onClick={() => this.props.onClose()}>
                    Close
                </Button>
                <Button variant="primary"  disabled={this.state.buttonDisabled} 
                    onClick={() => this.disableButton()}>
                    Start
                </Button>
            </div>
        </Modal.Body>
      </Modal>
     
    </>
  }

  componentDidMount()
  {
    this.prepareFinalModal();
  }

  disableButton(){
    this.setState({buttonDisabled: true});
    this.props.onSave();
  }

 
}
export default FinalConfirmModal;